import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/ela/grade-k7/question-2.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k7/question-5.png'
import imgQuestion7 from '../../../../ui/images/questions/ela/grade-k7/question-7.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k7_1',
    title: 'If someone says, “That’s the last straw,” what do they mean?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k7_1_a',
        text: 'They are feeling very relaxed.',
      },
      {
        name: 'grade_k7_1_b',
        text: 'They are ready to take a break.',
      },
      {
        name: 'grade_k7_1_c',
        text: 'They have reached their limit of patience.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_2',
    title: 'You hear this statement in a group discussion:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“I see your point, but have you thought about it this way?”',
    sentence: 'What is the speaker doing?',
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k7_2_a',
        text: 'Ignoring others’ ideas.',
      },
      {
        name: 'grade_k7_2_b',
        text: 'Agreeing without question.',
      },
      {
        name: 'grade_k7_2_c',
        text: 'Offering a different perspective politely.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_3',
    title: 'You hear these instructions:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“After you finish your worksheet, please pack up your materials quietly and wait for the next activity.”',
    sentence: 'What should you do first?',
    answers: [
      {
        name: 'grade_k7_3_a',
        text: 'Pack up your materials.',
      },
      {
        name: 'grade_k7_3_b',
        text: 'Wait for the next activity.',
      },
      {
        name: 'grade_k7_3_c',
        text: 'Finish your worksheet.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_4',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'As the sun set behind the mountains, a cool breeze swept through the valley. Marcus paused to admire the view, feeling a mix of excitement and nervousness. Tomorrow would be the first day of his new adventure — starting at a school far from home.',
    sentence: 'What is the main idea of the passage?',
    answers: [
      {
        name: 'grade_k7_4_a',
        text: 'Marcus is afraid of the dark.',
      },
      {
        name: 'grade_k7_4_b',
        text: 'Marcus enjoys watching sunsets.',
      },
      {
        name: 'grade_k7_4_c',
        text: 'Marcus is preparing for a new experience away from home.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_5',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Renewable energy sources like solar and wind power are becoming more popular because they are cleaner and more sustainable than fossil fuels. Unlike coal and oil, these sources do not produce harmful emissions that contribute to climate change. Many countries are investing in renewable energy to protect the environment and create jobs.',
    sentence: 'What is the main purpose of this passage?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k7_5_a',
        text: 'To explain how fossil fuels work.',
      },
      {
        name: 'grade_k7_5_b',
        text: 'To inform readers about the benefits of renewable energy.',
        correct: true,
      },
      {
        name: 'grade_k7_5_c',
        text: 'To describe the process of climate change.',
      },
    ],
  },
  {
    name: 'grade_k7_6',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Sophia stared out the window as rain tapped steadily against the glass. She clutched her notebook tightly, hoping the words would come. The story she wanted to write felt just out of reach, like a dream slipping away as she tried to grasp it.',
    sentence: 'What is Sophia most likely feeling?',
    answers: [
      {
        name: 'grade_k7_6_a',
        text: 'Confident and excited.',
      },
      {
        name: 'grade_k7_6_b',
        text: 'Frustrated and stuck.',
        correct: true,
      },
      {
        name: 'grade_k7_6_c',
        text: 'Angry and upset.',
      },
    ],
  },
  {
    name: 'grade_k7_7',
    title: 'The teacher was very ________ because she explained the lesson clearly.',
    topic: AssessmentTopics.Writing,
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k7_7_a',
        text: 'confused',
      },
      {
        name: 'grade_k7_7_b',
        text: 'angry',
      },
      {
        name: 'grade_k7_7_c',
        text: 'patient',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_8',
    title: 'Which sentence uses a semicolon correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k7_8_a',
        text: 'I went to the store; and bought some milk.',
      },
      {
        name: 'grade_k7_8_b',
        text: 'I went to the store; bought some milk.',
      },
      {
        name: 'grade_k7_8_c',
        text: 'I went to the store; I bought some milk.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_9',
    title: 'Which sentence best maintains paragraph coherence?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k7_9_a',
        text: 'Dogs are great pets. Cats can be playful. Fish live in water.',
      },
      {
        name: 'grade_k7_9_b',
        text: 'Dogs are great pets because they are loyal and friendly. Many people enjoy having dogs as companions.',
        correct: true,
      },
      {
        name: 'grade_k7_9_c',
        text: 'Dogs are great pets. I like ice cream. Cats are cute.',
      },
    ],
  },
  {
    name: 'grade_k7_10',
    title: 'Which sentence uses the correct form of the verb?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k7_10_a',
        text: 'She don’t like going to the park.',
      },
      {
        name: 'grade_k7_10_b',
        text: 'She doesn’t like going to the park.',
        correct: true,
      },
      {
        name: 'grade_k7_10_c',
        text: 'She doesn’t likes going to the park.',
      },
    ],
  },
  {
    name: 'grade_k7_11',
    title: 'Which sentence is written in passive voice?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k7_11_a',
        text: 'The teacher gave the students homework.',
      },
      {
        name: 'grade_k7_11_b',
        text: 'The homework was given to the students by the teacher.',
        correct: true,
      },
      {
        name: 'grade_k7_11_c',
        text: 'The students completed their homework.',
      },
    ],
  },
  {
    name: 'grade_k7_12',
    title: 'Which sentence uses commas correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k7_12_a',
        text: 'Before the movie started we bought, popcorn and drinks.',
      },
      {
        name: 'grade_k7_12_b',
        text: 'Before the movie started, we bought popcorn and drinks.',
        correct: true,
      },
      {
        name: 'grade_k7_12_c',
        text: 'Before the movie, started we bought popcorn and drinks.',
      },
    ],
  },
]
